import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';

import {
    REINITIALIZE,
    FORM_VALID_AFYA_IMARA_QUOTE_FORM,
    FORM_INVALID_AFYA_IMARA_QUOTE_FORM,
    API_FAILURE_TRANSITION_AFYA_IMARA_QUOTE_FORM,
    API_SUCCESS_TRANSITION_AFYA_IMARA_QUOTE_FORM,
    API_PENDING_TRANSITION_AFYA_IMARA_QUOTE_FORM,
    COLLECT_AFYA_IMARA_QUOTE_FORM_DATA,
    SUBMIT_AFYA_IMARA_QUOTE_SUCCESS,
    SUBMIT_AFYA_IMARA_QUOTE_FAILURE,
    AFYA_IMARA_SIDEBAR_OPEN_VALUE,
    AFYA_IMARA_SHARE_QUOTE_VALUE,
    SET_SHARE_EMAIL_VALUE,
    SET_SHARE_EMAIL_VALID,
    FORM_VALID_AFYA_IMARA_QUOTE_SHARE_FORM,
    FORM_INVALID_AFYA_IMARA_QUOTE_SHARE_FORM,
    COLLECT_SHARE_QUOTE_FORM_DATA,
    SHARE_AFYA_IMARA_QUOTE_SUCCESS,
    SHARE_AFYA_IMARA_QUOTE_FAILURE,
    API_PENDING_TRANSITIONS_SHARE_QUOTE_FORM,
    API_SUCCESS_TRANSITIONS_SHARE_QUOTE_FORM,
    API_FAILURE_TRANSITIONS_SHARE_QUOTE_FORM,
    CALCULATE_AFYA_IMARA_PREMIUM_SUCCESS,
    CALCULATE_AFYA_IMARA_PREMIUM_FAILURE,
    TOKEN_IS_EXPIRED,
    setExpiredAuth,
    //new values
    DOB_SET_VALUE,
    DOB_SET_VALID,
    COVER_LIMIT_SET_VALUE,
    COVER_LIMIT_SET_VALID,
    PROFESSION_SET_VALUE,
    PROFESSION_SET_VALID,
    SPOUSE_INCLUDED_SET_VALUE,
    SPOUSE_INCLUDED_SET_VALID,
    SPOUSE_DOB_SET_VALUE,
    SPOUSE_DOB_SET_VALID,
    CHILDREN_INCLUDED_SET_VALUE,
    CHILDREN_INCLUDED_SET_VALID,
    CHILDREN_DOBS_SET_VALUE,
    CHILDREN_DOBS_SET_VALID,
    AFYA_IMARA_QUOTE_ADD_COVER,
    AFYA_IMARA_QUOTE_SHOW_COVER_OPTIONS,
    SELECTED_COVER_OPTION_SET_VALUE,
    SET_COVER_OPTIONS_LIST_VALID,
    SET_COVER_OPTIONS_LIST_VALUE,
    SET_INPATIENT_COVER_VALID,
    SET_INPATIENT_COVER_VALUE,
    SET_OUTPATIENT_COVER_VALID,
    SET_OUTPATIENT_COVER_VALUE,
    SET_OUTPATIENT_COVER_OPTION_VALUE,
    SET_OUTPATIENT_COVER_OPTION_VALID,
    API_PENDING_TRANSITIONS_PRODUCTS,
    API_SUCCESS_TRANSITIONS_PRODUCTS,
    API_FAILURE_TRANSITIONS_PRODUCTS,
    SET_AFYA_IMARA_PRODUCTS_VALUE,
    SET_AFYA_IMARA_PRODUCTS_VALID,
    SET_SELECTED_PRODUCT_ID,
    SET_SELECTED_AFYA_IMARA_PLAN,
    // comparison trasnsions
    API_PENDING_TRANSITION_AFYA_IMARA_COMPARISON,
    API_SUCCESS_TRANSITION_AFYA_IMARA_COMPARISON,
    API_FAILURE_TRANSITION_AFYA_IMARA_COMPARISON,
    COMPARISONS_DATA_FETCH_SUCCESS,
    SET_SELECTED_PLAN_INDEX,
    SET_OUTPATIENT_LIMIT_VALUE,
    CHILDREN_DOBS_ARRAY_SET_VALID,
    CHILDREN_DOBS_ARRAY_SET_VALUE,
    API_PENDING_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM,
    API_SUCCESS_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM,
    API_FAILURE_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM,
    API_INITIAL_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM,
    PAGE_NAME_SET_VALUE,
    SET_AFYA_IMARA_OM_RESCUE_PLUS_VALUE,
    SET_AFYA_IMARA_OM_RESCUE_PLUS_VALID,
    SET_FULL_NAME_VALUE,
    SET_FULL_NAME_VALID,
    SET_EMAIL_VALUE,
    SET_EMAIL_VALID,
    SET_PHONE_NO_VALUE,
    SET_PHONE_NO_VALID,
} from '../../actions/afyaImara/quote';

export const initQuote = {
    sidebarOpen: false,
    formStatus: FORM_STATUS.INVALID,
    comparisonApiCallStatus: null,
    apiCallStatus: null,
    apiPayloadCollectionStatus: null,
    pageName: null,
    coverOptionsApiStatus: null,
    quoteReferenceData: null,
    addedCover: null,
    showCoverOptions: false,
    showShareModal: false,
    shareQuoteFormStatus: FORM_STATUS.INVALID,
    shareQuoteAPIStatus: null,
    quoteShared: null,
    isTokenExpired: false,
    valuers: null,
    comparisonData: null,
    products: [],
    apiPendingProducts: null,
    selectedPlanIndex: null,
    selectedPlanIndexComparison: null,
    premium: null,
    productId: 0, //default set to afya imara family
    ugCmbObject: {
        __typename: 'Contentstack_call_me_back_ke',
        product: 'AFYA IMARA KENYA',
        privacy_policy_url: '/privacy-policy',
        extra_fields: ['Email Address'],
    },
    selectedCoverOption: { value: null, status: null, error: null },
    form: {
        shareEmail: { value: null, error: null, status: null },
        //new values
        dob: { value: null, error: null, status: null },
        coverLimit: { value: null, error: null, status: null },
        profession: { value: null, error: null, status: null },
        spouseIncluded: { value: null, error: null, status: null },
        spouseDob: { value: null, error: null, status: null },
        childrenIncluded: { value: null, error: null, status: null },
        childrenDobs: { value: [], error: null, status: null },
        coverOptions: { value: null, error: null, status: null },
        inpatientCover: { value: null, error: null, status: null },
        outpatientCover: { value: null, error: null, status: null },
        outpatientLimit: { value: null, error: null, status: null },
        outpatientCoverOption: { value: 'per family per annum', error: null, status: 'valid' },
        omRescuePlus: { value: null, error: null, status: null },
        fullName: { value: null, error: null, status: null },
        email: { value: null, error: null, status: null },
        phoneNumber: { value: null, error: null, status: null },
    },
};

export default (state = initQuote, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    switch (action.type) {
        case FORM_VALID_AFYA_IMARA_QUOTE_FORM:
            return {
                ...state,
                formStatus: FORM_STATUS.VALID,
            };
        case FORM_INVALID_AFYA_IMARA_QUOTE_FORM:
            return {
                ...state,
                formStatus: FORM_STATUS.INVALID,
            };

        case FORM_VALID_AFYA_IMARA_QUOTE_SHARE_FORM:
            return {
                ...state,
                shareQuoteFormStatus: FORM_STATUS.VALID,
            };

        case FORM_INVALID_AFYA_IMARA_QUOTE_SHARE_FORM:
            return {
                ...state,
                shareQuoteFormStatus: FORM_STATUS.INVALID,
            };

        case SET_SELECTED_PRODUCT_ID:
            return {
                ...state,
                productId: action.value?.toString(),
            };
        case SET_SELECTED_AFYA_IMARA_PLAN:
            return {
                ...state,
                selectedPlanIndex: action.value,
            };

        case SET_SELECTED_PLAN_INDEX:
            return {
                ...state,
                selectedPlanIndexComparison: action.value,
            };

        // API Calls products
        case API_PENDING_TRANSITIONS_PRODUCTS:
            return {
                ...state,
                apiPendingProducts: API_CALL_STATUS.PENDING,
            };

        case API_SUCCESS_TRANSITIONS_PRODUCTS:
            return {
                ...state,
                apiPendingProducts: API_CALL_STATUS.SUCCESS,
            };

        case API_FAILURE_TRANSITIONS_PRODUCTS:
            return {
                ...state,
                apiPendingProducts: API_CALL_STATUS.FAILURE,
            };

        // comparison transitions
        case API_PENDING_TRANSITION_AFYA_IMARA_COMPARISON:
            return {
                ...state,
                comparisonApiCallStatus: API_CALL_STATUS.PENDING,
            };

        case API_SUCCESS_TRANSITION_AFYA_IMARA_COMPARISON:
            return {
                ...state,
                comparisonApiCallStatus: API_CALL_STATUS.SUCCESS,
            };

        case API_FAILURE_TRANSITION_AFYA_IMARA_COMPARISON:
            return {
                ...state,
                comparisonApiCallStatus: API_CALL_STATUS.FAILURE,
            };

        case COMPARISONS_DATA_FETCH_SUCCESS:
            return {
                ...state,
                comparisonData: action.value,
            };
        //  products
        case SET_AFYA_IMARA_PRODUCTS_VALUE:
            return {
                ...state,
                products: action.value,
            };

        case SET_AFYA_IMARA_PRODUCTS_VALID:
            return {
                ...state,
                products: action.error,
            };

        // premium
        case CALCULATE_AFYA_IMARA_PREMIUM_SUCCESS:
            return {
                ...state,
                premium: action.value,
            };

        case CALCULATE_AFYA_IMARA_PREMIUM_FAILURE:
            return {
                ...state,
                premium: action.error,
            };

        // Sidebar open
        case AFYA_IMARA_SIDEBAR_OPEN_VALUE:
            return {
                ...state,
                sidebarOpen: action.value,
            };

        // Share modal
        case AFYA_IMARA_SHARE_QUOTE_VALUE:
            return {
                ...state,
                showShareModal: action.value,
            };

        case COLLECT_SHARE_QUOTE_FORM_DATA:
            return {
                ...state,
                shareQuoteFormStatus: FORM_STATUS.VALID,
            };

        case SHARE_AFYA_IMARA_QUOTE_SUCCESS:
            return {
                ...state,
                quoteShare: action.value,
            };

        case SHARE_AFYA_IMARA_QUOTE_FAILURE:
            return {
                ...state,
                quoteShare: action.error,
            };

        case SET_SHARE_EMAIL_VALUE:
            return updateFormField('shareEmail', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_SHARE_EMAIL_VALID:
            return updateFormField('shareEmail', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_COVER_OPTIONS_LIST_VALUE:
            return updateFormField('coverOptions', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_COVER_OPTIONS_LIST_VALID:
            return updateFormField('coverOptions', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_INPATIENT_COVER_VALUE:
            return updateFormField('inpatientCover', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_INPATIENT_COVER_VALID:
            return updateFormField('inpatientCover', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_OUTPATIENT_COVER_VALUE:
            return updateFormField('outpatientCover', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_OUTPATIENT_COVER_VALID:
            return updateFormField('outpatientCover', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_OUTPATIENT_LIMIT_VALUE:
            return updateFormField('outpatientLimit', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_OUTPATIENT_COVER_OPTION_VALUE:
            return updateFormField('outpatientCoverOption', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_OUTPATIENT_COVER_OPTION_VALID:
            return updateFormField('outpatientCoverOption', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));
        case SET_FULL_NAME_VALUE:
            return updateFormField('fullName', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_FULL_NAME_VALID:
            return updateFormField('fullName', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_EMAIL_VALUE:
            return updateFormField('email', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_EMAIL_VALID:
            return updateFormField('email', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case SET_PHONE_NO_VALUE:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_PHONE_NO_VALID:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                status: mapError(action.error),
                error: action.error,
            }));

        case TOKEN_IS_EXPIRED:
            return {
                ...state,
                isTokenExpired: action.value,
            };

        // API Calls
        case PAGE_NAME_SET_VALUE:
            return {
                ...state,
                pageName: action.value,
            };

        case API_PENDING_TRANSITION_AFYA_IMARA_QUOTE_FORM:
            return {
                ...state,
                apiCallStatus: API_CALL_STATUS.PENDING,
            };
        case API_SUCCESS_TRANSITION_AFYA_IMARA_QUOTE_FORM:
            return {
                ...state,
                apiCallStatus: API_CALL_STATUS.SUCCESS,
            };
        case API_FAILURE_TRANSITION_AFYA_IMARA_QUOTE_FORM:
            return {
                ...state,
                apiCallStatus: API_CALL_STATUS.FAILURE,
            };

        case API_PENDING_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM:
            return {
                ...state,
                apiPayloadCollectionStatus: API_CALL_STATUS.PENDING,
            };
        case API_SUCCESS_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM:
            return {
                ...state,
                apiPayloadCollectionStatus: API_CALL_STATUS.SUCCESS,
            };
        case API_FAILURE_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM:
            return {
                ...state,
                apiPayloadCollectionStatus: API_CALL_STATUS.FAILURE,
            };
        case API_INITIAL_TRANSITION_QUOTE_PAYLOAD_COLLECTION_FORM:
            return {
                ...state,
                apiPayloadCollectionStatus: null,
            };

        case API_PENDING_TRANSITIONS_SHARE_QUOTE_FORM:
            return {
                ...state,
                shareQuoteAPIStatus: API_CALL_STATUS.PENDING,
            };

        case API_SUCCESS_TRANSITIONS_SHARE_QUOTE_FORM:
            return {
                ...state,
                shareQuoteAPIStatus: API_CALL_STATUS.SUCCESS,
            };

        case API_FAILURE_TRANSITIONS_SHARE_QUOTE_FORM:
            return {
                ...state,
                shareQuoteAPIStatus: API_CALL_STATUS.FAILURE,
            };

        // Submit user data
        case COLLECT_AFYA_IMARA_QUOTE_FORM_DATA:
            return {
                ...state,
                formStatus: FORM_STATUS.VALID,
            };

        case SUBMIT_AFYA_IMARA_QUOTE_SUCCESS:
            return {
                ...state,
                quoteReferenceData: action.value,
            };

        case SUBMIT_AFYA_IMARA_QUOTE_FAILURE:
            return {
                ...state,
                quoteReferenceData: action.error,
            };

        case SELECTED_COVER_OPTION_SET_VALUE:
            return {
                ...state,
                selectedCoverOption: {
                    ...state.selectedCoverOption,
                    value: action.value,
                    status: API_CALL_STATUS.SUCCESS,
                },
            };

        case SET_AFYA_IMARA_OM_RESCUE_PLUS_VALUE:
            return updateFormField('omRescuePlus', (field) => ({
                ...field,
                value: action.value,
            }));

        case SET_AFYA_IMARA_OM_RESCUE_PLUS_VALID:
            return updateFormField('omRescuePlus', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        //new values
        case DOB_SET_VALUE:
            return updateFormField('dob', (field) => ({
                ...field,
                value: action.value,
            }));

        case DOB_SET_VALID:
            return updateFormField('dob', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case COVER_LIMIT_SET_VALUE:
            return updateFormField('coverLimit', (field) => ({
                ...field,
                value: action.value,
            }));

        case COVER_LIMIT_SET_VALID:
            return updateFormField('coverLimit', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PROFESSION_SET_VALUE:
            return updateFormField('profession', (field) => ({
                ...field,
                value: action.value,
            }));

        case PROFESSION_SET_VALID:
            return updateFormField('profession', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SPOUSE_INCLUDED_SET_VALUE:
            return updateFormField('spouseIncluded', (field) => ({
                ...field,
                value: action.value,
            }));

        case SPOUSE_INCLUDED_SET_VALID:
            return updateFormField('spouseIncluded', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SPOUSE_DOB_SET_VALUE:
            return updateFormField('spouseDob', (field) => ({
                ...field,
                value: action.value,
            }));

        case SPOUSE_DOB_SET_VALID:
            return updateFormField('spouseDob', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case CHILDREN_DOBS_ARRAY_SET_VALUE:
            return updateFormField('childrenDobs', (field) => ({
                ...field,
                value: action.value,
            }));

        case CHILDREN_INCLUDED_SET_VALUE:
            return updateFormField('childrenIncluded', (field) => ({
                ...field,
                value: action.value,
            }));

        case CHILDREN_INCLUDED_SET_VALID:
            return updateFormField('childrenIncluded', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case CHILDREN_DOBS_SET_VALUE:
            const { index, newValue } = action.value;

            if (typeof index === 'undefined') {
                return {
                    ...state,
                    form: {
                        ...state.form,
                        childrenDobs: {
                            ...state.form.childrenDobs,
                            value: [...state.form.childrenDobs.value, newValue],
                        },
                    },
                };
            } else {
                const updatedValueArray = [...state.form.childrenDobs.value];
                updatedValueArray[index] = newValue;

                return {
                    ...state,
                    form: {
                        ...state.form,
                        childrenDobs: {
                            ...state.form.childrenDobs,
                            value: updatedValueArray,
                        },
                    },
                };
            }

        case CHILDREN_DOBS_SET_VALID:
            return updateFormField('childrenDobs', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case AFYA_IMARA_QUOTE_ADD_COVER:
            return {
                ...state,
                addedCover: action.value,
            };

        case AFYA_IMARA_QUOTE_SHOW_COVER_OPTIONS:
            return {
                ...state,
                showCoverOptions: action.value,
            };

        // Reset state
        case REINITIALIZE:
            return initQuote;
        default:
            return state;
    }
};
